import { lazy } from "react";
import type { ComponentType, LazyExoticComponent } from "react";

export const CHUNK_RELOAD_KEY = "chunk-reload-attempted";

function isChunkLoadError(error: unknown): boolean {
  if (error instanceof Error) {
    return (
      error.message.includes("dynamically imported module") ||
      error.message.includes("Loading chunk") ||
      error.message.includes("Loading CSS chunk") ||
      error.message.includes("Unable to preload CSS")
    );
  }
  return false;
}

export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      const component = await factory();
      sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      return component;
    } catch (error) {
      if (isChunkLoadError(error)) {
        if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
          sessionStorage.setItem(CHUNK_RELOAD_KEY, Date.now().toString());
          window.location.reload();
          return new Promise(() => {});
        }
        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
      }
      throw error;
    }
  });
}
